class CookieService {
    readCookie = (name: string) => {
        return document.cookie.split("; ").reduce((r, v) => {
            const parts = v.split("=");
            return parts[0] === name ? decodeURIComponent(parts[1]) : r;
        }, "");
    };
}

export default new CookieService();
